export type NotificationState = {
  notifications: NotificationSingle[];
};

// Naming `NotificationSingle` instead of `Notification`
// because of conflict with Notification API interface
export type NotificationSingle = {
  type: NotificationType;
  message: string;
  id?: number;
};

export enum NotificationType {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
  DEFAULT = "",
}

// Issue
export type Issue = {
  type: NotificationType;
  message: string;
  icon: string; // e.g. exclamation-circle
};
